var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row-article-name"},[(_vm.data.icon)?_c('img',{attrs:{"src":_vm._f("s3url")(_vm.data.icon)}}):_vm._e(),_c('div',[_vm._v(_vm._s(_vm.data.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }